import { PaymentPriceDTO } from '@app/src/views/StepPayment/formPayment/dtos';
import { PaymentPriceModel } from '@app/src/views/StepPayment/formPayment/models/PaymentPriceModel';

export const hydrateData = (data: PaymentPriceDTO) => ({
  subTotal: data.sub_total,
  igv: data.igv,
  igvTotal: data.igv_total,
  total: data.total
} as PaymentPriceModel)
